function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_644",
  "data-name": "Group 644",
  transform: "translate(-916.417 -39.22)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_191",
  "data-name": "Rectangle 191",
  width: 27.046,
  height: 16.994,
  rx: 3,
  transform: "translate(917.667 40.47)",
  fill: "none",
  stroke: "#213368",
  strokeMiterlimit: 10,
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_658",
  "data-name": "Path 658",
  d: "M949.284,52.591l-9.358,4.272-9.6-4.484",
  transform: "translate(-8.617 -7.896)",
  fill: "none",
  stroke: "#d71635",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}));

var SvgIconEmail = function SvgIconEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.546,
    height: 19.494,
    viewBox: "0 0 29.546 19.494",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconEmail.2327bd25.svg";
export { ForwardRef as ReactComponent };